module.exports = __webpack_public_path__ + "static/media/empty-survey-icon.40da1823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty-survey-icon.png
// module id = 1260
// module chunks = 0